import * as React from 'react';

export default class NumberSpinnerExtended extends React.Component<
    {
        value?: number;

        //LL: new in Extended:
        integer?: boolean; // default true
        precision?: number; // default 1 - for float, i.e. when not integer
        //positive?: boolean;
        //notNegative?: boolean;
        min?: number; // default 0
        max?: number; // default not set
        step?: number; // default 1
        placeholder?: string; // default not set
        withTooltip?: boolean; // default true
        allowNull?: boolean; // default true   NOT USED, always allow

        applyOnEnter?: boolean; //LL: 27.05.19

        onChange(value: number);
    },
    {}
> {
    constructor(props) {
        super(props);
    }

    //LL: sample:
    //<NumberSpinnerExtended
    //    value={ displayVal }
    //    step={ 0.2 }
    //    integer={ false }
    //    max={ 2.5 }
    //    min={ 1 }
    //    precision={ 2 }
    //    onChange={ this.processWidthChange }
    ///>

    //LL: new in Extended:
    isInteger = () => {
        return this.props.integer != null ? this.props.integer : true;
    };

    //LL: new in Extended:
    isWithTooltip = () => {
        return this.props.withTooltip != null ? this.props.withTooltip : true;
    };

    //LL: new in Extended:   NOT USED
    isAllowNull = () => {
        return this.props.allowNull != null ? this.props.allowNull : true;
    };

    //LL: new in Extended:
    getPrecision = () => {
        return this.props.precision != null && this.props.precision >= 0 ? this.props.precision : 1;
    };

    //LL: new in Extended:
    getStep = () => {
        return this.props.step != null ? this.props.step : 1;
    };

    //LL: new in Extended:
    getMax = () => {
        return this.props.max != null ? this.props.max : null;
    };

    //LL: new in Extended:
    getMin = () => {
        return this.props.min != null ? this.props.min : 0;
    };

    //LL: new in Extended:
    isAboveMax = (value) => {
        let max = this.getMax();
        return max != null ? value > max : false;
    };

    //LL: new in Extended:
    isBelowMin = (value) => {
        let min = this.getMin();
        return min != null ? value < min : false;
    };

    handleChange = (value) => {
        let parsed;

        if (typeof value === 'string') {
            // when entered in TextField
            //LL: new in Extended:
            if (this.isInteger()) {
                parsed = parseInt(value);
            } else {
                parsed = parseFloat(value);
                parsed.toFixed(this.getPrecision());
            }
        } else {
            parsed = value;
        }

        if (value === '') {
            value = null;
        }

        //LL: new in Extended:
        else if (!isNaN(parsed)) {
            if (this.isAboveMax(parsed)) {
                value = this.getMax();
            } else if (this.isBelowMin(parsed)) {
                value = this.getMin();
            } else {
                value = parsed;
            }
        } else {
            return;
        }

        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    };

    // ===============  //LL: 13.03.19: input type=number

    //LL: 13.03.19: input type=number
    //LL: see StringField
    getTargetValue(e) {
        let value = e.target.value;
        return value;
    }

    //LL: 13.03.19: input type=number   onInput
    handleChange_InputTypeNumber = (e) => {
        const value = this.getTargetValue(e);
        //console.log("handleChange_InputTypeNumber value = " + value);
        this.handleChange(value);
    };

    render() {
        //LL: new in Extended:
        let value;
        if (this.props.value != null) {
            if (this.isInteger()) {
                value = this.props.value.toString();
            } else {
                value = this.props.value.toFixed(this.getPrecision());
            }
        } else {
            value = '';
        }

        //LL: new in Extended:
        let title;
        if (this.isWithTooltip()) {
            let int = this.isInteger() ? 'integer' : 'float';
            title = int + ' step=' + this.getStep() + ' max=' + this.getMax() + ' min=' + this.getMin();
        }

        //LL: 13.03.19: input type=number
        //    Sadly, though, only Opera and Chrome support the spinner
        //    <INPUT TYPE="NUMBER" MIN="0" MAX="10" STEP="2" VALUE="6" SIZE="6">
        //    https://developer.mozilla.org/ru/docs/Web/HTML/Element/Input/number      <=========

        //LL: onChange={ () => { } } //Is added to fix red warning.  (see StringField)

        //min={ 0 }
        //max={ 10 }
        //step={ 2 }

        let step = this.getStep();
        let max = this.getMax();
        let min = this.getMin();
        let placeholder = this.props.placeholder != null ? this.props.placeholder : '';
        //  onBlur={ this.handleBlur }  //LL: 27.05.19  see NumberField
        //  onKeyUp={ this.handleKeyUp }   //LL: 27.05.19  see NumberField

        return (
            <div className="number-spinner-extended">
                <div className="input-number" title={title}>
                    <input
                        className="form-control"
                        type="number"
                        value={value}
                        min={min}
                        max={max}
                        step={step}
                        placeholder={placeholder}
                        onInput={this.handleChange_InputTypeNumber}
                        onChange={() => {}}
                    />
                </div>
            </div>
        );
    }
}
